import { render, staticRenderFns } from "./ProviderDocuments.vue?vue&type=template&id=679cb506&scoped=true"
import script from "./ProviderDocuments.vue?vue&type=script&lang=js"
export * from "./ProviderDocuments.vue?vue&type=script&lang=js"
import style0 from "./ProviderDocuments.vue?vue&type=style&index=0&id=679cb506&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679cb506",
  null
  
)

export default component.exports